import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useForm } from 'react-hook-form';
import { makeStyles } from '@material-ui/core';

import OnOffByScroll from '../../../Animation/onOffByScroll';
import { AuthContext } from '../../../auth';
import various from '../../../General/various';
import Footer from '../../../Footer/footer';
import { localStorageArrayHandler } from '../../../CommonFunction/managePermission';
import { seminarDetailPreview, seminarRemindMail } from '../../../Apis/apis';
import BreadCrumbs from '../../../General/breadCrumbs';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    margin: '0px 0px 80px 0px',
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      textAlign: 'start',
      '& > span': {
        display: 'inline-block',
        marginRight: '24px',
        fontSize: '0.9rem',
      },
      '& #title': {
        fontWeight: 'bold',
        fontSize: theme.typography.fontSize,
      },
    },
  },
  titles: {},
  inputs: {},
  helptext: {},
  error: {
    color: 'red',
    fontSize: '0.7em',
  },
  attentionBtn: {
    width: '100%',
    textAlign: 'start',
  },
  attention: {
    fontSize: '0.9rem',
    textAlign: 'start',
    marginLeft: '16px',
    '& > p': {
      fontWeight: 'bold',
      textDecoration: 'underline',
    },
  },
  container: {
    margin: '80px 0 0 16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '@media screen and (max-width:800px)': {
      '& > div': {
        width: '100%',
      },
    },
    '& > form': {
      '& > div': {
        width: '100%',
        display: 'flex',
        margin: '0 auto',
        marginBottom: '32px',

        '& > div': {
          textAlign: 'start',
          display: 'flex',
          justifyContent: 'start',
        },

        '& $titles': {
          width: '40%',
          marginRight: '32px',
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
          '& > label': {
            width: '100%',
            textAlign: 'end',
            fontSize: '1rem',
            '@media screen and (max-width:750px)': {
              textAlign: 'start',
              marginBottom: '16px',
            },
          },
          '& > span': {
            color: 'red',
            fontSize: '0.6rem',
          },
        },

        '& $inputs': {
          width: '100%',
          flexWrap: 'wrap',
          '& > input, & > textarea': {
            width: '100%',
            height: '40px',
            padding: '8px',
            fontFamily: theme.typography.fontFamily,
            border: '0.5px solid grey',
            borderRadius: '0.5em',
            boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.1) inset',
            '&:focus': {
              outline: `1.2px ${theme.palette.primary.main} outset`,
            },
          },
          '& > textarea': {
            minHeight: '420px',
          },
          '& $helptext': {
            fontSize: '0.8rem',
            color: 'grey',
            '& > a': {
              textDecoration: 'underline',
              '&:link': {
                color: theme.palette.primary.main,
              },
            },
          },
        },

        '@media screen and (max-width:750px)': {
          flexWrap: 'wrap',
        },
      },
    },
  },
  button: {
    width: '100%',
    marginTop: '88px !important',
    justifyContent: 'end',
    '& > button': {
      width: '100%',
      display: 'block',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 'bold',
      borderRadius: '0.5em',
      border: 'none',
      padding: '4px 8px',
      backgroundColor: theme.palette.primary.main,
      boxShadow: '0px 0px 15px rgba(0,0,0,0.1)',
      color: '#fff',
      cursor: 'pointer',
    },
  },
}));

const SeminarRemindMail = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    defaultValues: {},
  });

  const { isAuth } = useContext(AuthContext);
  const permissions = localStorageArrayHandler('parse', various.permissionKey);

  const [date, setDate] = useState();
  const [detail, setDetail] = useState();
  const [uuid, setUuid] = useState();
  const [hasDocument, setHasDocument] = useState(false);
  const [showAttention, setShowAttention] = useState(false);

  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const CRUMBS = [
    { name: '管理画面Top', path: '/manage/index' },
    { name: 'セミナー一覧', path: '/seminar_index' },
    { name: 'セミナーリマインドメール', path: '/seminar_remind_mail' },
  ];

  // if (detail) console.log('seminar:', detail);
  // console.log('hasDocument:', hasDocument);

  // Init
  useEffect(() => {
    const weekday = ['日', '月', '火', '水', '木', '金', '土'];
    const d = new Date();
    setDate(
      d.getFullYear() +
        '年' +
        (d.getMonth() + 1) +
        '月' +
        d.getDate() +
        '日' +
        '（' +
        weekday[d.getDay()] +
        '）'
    );
  }, []);

  useEffect(() => {
    setUuid(location.state.uuid);
  }, [location]);

  useEffect(() => {
    if (uuid) {
      seminarDetailPreview(setDetail, uuid);
    }
  }, [uuid]);

  useEffect(() => {
    if (detail) {
      if (Object.keys(detail.documents).length > 0) {
        setHasDocument(true);
      }
    }
  }, [detail]);

  // Handler
  const handleAuth = () => {
    navigate(various.general.login, { state: { previous: location.pathname } });
  };

  const handleAttention = () => {
    setShowAttention(!showAttention);
  };

  // Submit
  const onSubmit = handleSubmit((data) => {
    const seminar = detail;
    const title =
      seminar.title +
      (seminar.serial_number ? ' #' + seminar.serial_number : '');
    const payload = {
      uuid: seminar.uuid,
      title: title,
      mail_subject: data.mail_subject,
      announce: data.announce,
      is_attach_file: data.is_attach_file,
    };

    if (data.announce && data.announce.length <= 3) {
      payload['announce'] = null;
    }
    async function remindMail(payload) {
      await seminarRemindMail(payload);
    }
    remindMail(payload);
    console.log('send mail!');
    navigate(location.state.previous);
  });

  return (
    <>
      <div style={{ margin: '80px' }}>
        <OnOffByScroll place="General" />
      </div>
      {!isAuth ? (
        <>
          <div>
            <span
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={handleAuth}
            >
              ログイン
            </span>
            してください。
          </div>
          <Footer />
        </>
      ) : (permissions.includes('admin') ||
          permissions.includes('instructor') ||
          permissions.includes('organizer')) &&
        detail ? (
        <>
          <div className={classes.pageTitle}>
            <div>
              <span id="title">
                【{detail.title}
                {detail.serial_number ? ` #${detail.serial_number}` : null}
                】参加者への一斉メール送信
              </span>
              <span>{date}</span>
            </div>
          </div>
          <BreadCrumbs crumbs={CRUMBS} />
          <hr />
          <div className={classes.attentionBtn}>
            <button type="button" onClick={handleAttention}>
              留意事項
            </button>
          </div>
          {showAttention && (
            <div className={classes.attention}>
              <p>留意事項：</p>
              <ul>
                <li>
                  本機能とは別に、参加者に対する一斉リマインドメールは
                  <span
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    セミナー開催日"前日"の20時頃
                  </span>
                  に自動送信されます。
                </li>
                <li>本機能は何度でも使用可能です。ご注意ください。</li>
                <li>
                  一斉送信メールは、現時点で参加登録している方々全てに送信されます。個別でのメール送信はサポート範囲外です。
                </li>
              </ul>
              <p>本機能の使用を想定できるケース：</p>
              <ul>
                <li>指導者から何らかの案内を送信したい場合。</li>
                <li>
                  運営からのアナウンスが必要な場合に使用するケースがあります。
                </li>
              </ul>
            </div>
          )}
          <div className={classes.container}>
            <form
              method="POST"
              encType="multipart/form-data"
              onSubmit={onSubmit}
            >
              <div>
                <div className={classes.titles}>
                  <label htmlFor="件名">件名</label>
                  <span>※</span>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="mail_subject"
                    type="text"
                    {...register('mail_subject', {
                      required: { value: true, message: '入力必須の項目です' },
                    })}
                  />
                  {errors.mail_subject?.message && (
                    <div className={classes.error}>
                      {errors.mail_subject.message}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className={classes.titles}>
                  <label htmlFor="指導者からのアナウンス">
                    指導者からのアナウンス
                  </label>
                  <span>※</span>
                </div>
                <div className={classes.inputs}>
                  <textarea
                    id="announce"
                    type="textarea"
                    {...register('announce', {
                      required: { value: true, message: '入力必須の項目です' },
                    })}
                  />
                  <div className={classes.helptext}>
                    フリーフォーマットでご記入ください。
                  </div>
                  {errors.announce?.message && (
                    <div className={classes.error}>
                      {errors.announce.message}
                    </div>
                  )}
                </div>
              </div>
              {hasDocument && (
                <div>
                  <div className={classes.titles}>
                    <label htmlFor="資料添付">資料添付</label>
                  </div>
                  <div className={classes.inputs}>
                    <input
                      id="is_attach_file"
                      type="checkbox"
                      {...register('is_attach_file', {
                        required: {
                          value: false,
                          message: '入力必須の項目です',
                        },
                      })}
                    />
                    <div className={classes.helptext}>
                      本セミナーに資料が登録されている場合このメールに添付することができます。添付する場合はチェックを入れてください。
                    </div>
                    {errors.is_attach_file?.message && (
                      <div className={classes.error}>
                        {errors.is_attach_file.message}
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className={classes.button}>
                <button type="submit">送信</button>
              </div>
            </form>
          </div>
          <Footer />
        </>
      ) : permissions === 'null' ? (
        setTimeout(() => {
          window.location.reload(true);
        }, 500)
      ) : (
        <>
          <div className={classes.pageTitle}>
            <div>
              <span id="title">参加者への一斉メール送信</span>
              <span>{date}</span>
            </div>
          </div>
          <hr />
          <div className={classes.container}>権限がありません</div>
        </>
      )}
    </>
  );
};
export default SeminarRemindMail;
